<template>
    <div class="SiteHeaderWrapper">
        <div
            class="PromotionBar"
            v-if="showPromotion && (!isMobile || !isPromotionClosedMobile)"
            :class="{ 'PromotionBar--bottom': isMobile }"
        >
            <div class="PromotionContent">
                <i class="ri-coupon-2-line"></i>
                <span>
                    <b>TSE-COMPLIANCE:</b> Pflicht ab 2026 – jetzt TSE-konform mit uns!
                    <b>Aktion:</b> 50% Rabatt auf das Basic Paket - 8€ statt 16€.
                </span>
                <span v-if="isMobile && timeLeftString" class="PromotionCountdown">
                    <i class="ri-timer-line"></i>
                    {{ timeLeftString }}
                </span>
                <router-link :to="getPromotionRedirectUrl()" class="PromotionButton"
                    >Angebot sichern</router-link
                >
                <button
                    v-if="isMobile"
                    class="PromotionCloseButton"
                    @click="closePromotion"
                    aria-label="Promotion schließen"
                >
                    <i class="ri-close-line"></i>
                </button>
            </div>
        </div>

        <div
            class="SiteHeader"
            :class="{ 'is-scrolled': isScrolled, 'is-hidden': isHidden }"
            :style="headerStyle"
        >
            <div class="SiteHeader-Wrap">
                <router-link to="/" class="Logo">
                    <img src="../assets/svg/logo.svg" alt="TaxiFusion Logo" />
                </router-link>

                <nav class="Navigation">
                    <!-- Desktop Navigation -->
                    <div class="DesktopNav">
                        <component
                            :is="item.isRouterLink ? 'router-link' : 'a'"
                            v-for="(item, index) in regularNavItems"
                            :key="index"
                            :to="item.isRouterLink ? item.url : undefined"
                            :href="!item.isRouterLink ? item.url : undefined"
                            class="NavigationItem"
                            :class="{ isActive: item.active }"
                        >
                            {{ item.label }}
                        </component>
                        <router-link
                            v-if="blogNavItem"
                            class="NavigationItem"
                            :to="blogNavItem.url"
                            :class="{ isActive: blogNavItem.active }"
                            @click.native="trackBlogNavigation('header', 'desktop')"
                        >
                            {{ blogNavItem.label }}
                        </router-link>
                    </div>

                    <div class="AuthButtons">
                        <router-link to="/register?source=header_desktop" v-if="!isMobile">
                            <SiteButton size="small" variant="outline">
                                Kostenlos registrieren
                            </SiteButton>
                        </router-link>
                        <router-link to="/sign-in">
                            <SiteButton size="small">
                                <i class="ri-login-box-line"></i>
                                Login
                            </SiteButton>
                        </router-link>
                    </div>

                    <button class="Hamburger" @click="toggleMobileMenu" aria-label="Menu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </nav>
            </div>

            <transition name="slide-in">
                <div v-if="isMobileMenuOpen" class="MobileMenu">
                    <div class="MobileMenuHeader">
                        <div class="BrandingMobile">
                            <img
                                src="../assets/svg/logo.svg"
                                alt="TaxiFusion Logo"
                                class="MobileLogo"
                            />
                            <span class="MobileLogoText">TaxiFusion</span>
                        </div>
                        <button
                            class="MobileMenuClose"
                            @click="closeMobileMenu"
                            aria-label="Close menu"
                        >
                            <i class="ri-close-circle-line"></i>
                        </button>
                    </div>

                    <div class="MobileNavItems">
                        <component
                            :is="item.isRouterLink ? 'router-link' : 'a'"
                            v-for="(item, index) in regularNavItems"
                            :key="index"
                            :to="item.isRouterLink ? item.url : undefined"
                            :href="!item.isRouterLink ? item.url : undefined"
                            :class="{ isActive: item.active }"
                            @click="handleMobileNavClick(item)"
                            @click.native="item.isRouterLink ? closeMobileMenu : undefined"
                        >
                            {{ item.label }}
                        </component>
                        <router-link
                            v-if="blogNavItem"
                            :to="blogNavItem.url"
                            @click.native="handleBlogClick"
                            :class="{ isActive: blogNavItem.active }"
                        >
                            {{ blogNavItem.label }}
                        </router-link>
                    </div>

                    <div class="MobileAuthButtons">
                        <router-link
                            to="/register?source=header_mobile"
                            @click.native="closeMobileMenu"
                        >
                            <SiteButton size="small" variant="outline">
                                Kostenlos registrieren
                            </SiteButton>
                        </router-link>
                        <router-link to="/sign-in" @click.native="closeMobileMenu">
                            <SiteButton size="small">
                                <i class="ri-login-box-line"></i>
                                Login
                            </SiteButton>
                        </router-link>
                    </div>
                </div>
            </transition>

            <div v-if="isMobileMenuOpen" class="MobileMenuOverlay" @click="closeMobileMenu"></div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SiteButton from './SiteButton';
import { trackNavigation } from '@/services/analytics';

export default {
    name: 'SiteHeader',
    components: {
        SiteButton,
    },
    props: {
        topSpacing: {
            type: String,
            default: '80px',
            validator: function (value) {
                return /^(\d+(\.\d+)?(px|rem|em|vh|vw|%)|0)$/.test(value);
            },
        },
    },
    data() {
        return {
            isScrolled: false,
            isHidden: false,
            isMobileMenuOpen: false,
            isPromotionClosedMobile: false,
            windowWidth: window.innerWidth,
            lastScrollY: 0,
            scrollThreshold: 50,
            scrollTimer: null,
            countdownTimer: null,
            timeLeftMs: 0,
        };
    },
    computed: {
        ...mapGetters('promotion', ['showPromotion', 'promotionDeadline']),
        headerStyle() {
            const shouldShowPromotion =
                this.showPromotion && (!this.isMobile || !this.isPromotionClosedMobile);
            if (this.isScrolled) {
                return {
                    marginTop: '15px',
                };
            }
            return {
                marginTop: shouldShowPromotion ? this.topSpacing : '20px',
            };
        },
        isMobile() {
            return this.windowWidth <= 950;
        },
        timeLeftString() {
            if (!this.timeLeftMs || this.timeLeftMs <= 0) return '';
            const totalSeconds = Math.floor(this.timeLeftMs / 1000);
            const days = Math.floor(totalSeconds / 86400);
            let remainder = totalSeconds % 86400;
            const hours = Math.floor(remainder / 3600);
            remainder = remainder % 3600;
            const minutes = Math.floor(remainder / 60);
            const seconds = remainder % 60;

            const hh = hours.toString().padStart(2, '0');
            const mm = minutes.toString().padStart(2, '0');
            const ss = seconds.toString().padStart(2, '0');

            if (days > 0) {
                return `Endet in ${days}T ${hh}:${mm}:${ss}`;
            }
            return `Endet in ${hh}:${mm}:${ss}`;
        },
        isLandingPage() {
            return this.$route.path === '/';
        },
        navItems() {
            if (this.isLandingPage) {
                return [
                    { label: 'Features', url: '#features', active: false },
                    {
                        label: 'Einbauer',
                        url: '/einbauer',
                        isRouterLink: true,
                        active: false,
                    },
                    {
                        label: 'Webinar',
                        url: '/webinar',
                        isRouterLink: true,
                        active: false,
                    },
                    { label: 'Preise', url: '#pricing', active: false },
                    { label: 'Kontakt', url: '#contact', active: false },
                ];
            } else {
                return [
                    {
                        label: 'Features',
                        url: '/features',
                        isRouterLink: true,
                        active: this.$route.path === '/features',
                    },
                    {
                        label: 'Einbauer',
                        url: '/einbauer',
                        isRouterLink: true,
                        active: this.$route.path === '/einbauer',
                    },
                    {
                        label: 'Webinar',
                        url: '/webinar',
                        isRouterLink: true,
                        active: this.$route.path === '/webinar',
                    },
                    {
                        label: 'Preise',
                        url: '/pricing',
                        isRouterLink: true,
                        active: this.$route.path === '/pricing',
                    },
                    {
                        label: 'Kontakt',
                        url: '/contact',
                        isRouterLink: true,
                        active: this.$route.path === '/contact',
                    },
                ];
            }
        },
        regularNavItems() {
            return this.navItems.filter((item) => !item.isBlog);
        },
        blogNavItem() {
            return this.navItems.find((item) => item.isBlog);
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        this.handleScroll();
        this.checkStoredPromotionState();
        this.startCountdown();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
        if (this.countdownTimer) clearInterval(this.countdownTimer);
    },
    methods: {
        startCountdown() {
            const update = () => {
                const now = new Date();
                const diff = this.promotionDeadline - now;
                this.timeLeftMs = diff > 0 ? diff : 0;
                if (diff <= 0) {
                    if (this.countdownTimer) clearInterval(this.countdownTimer);
                }
            };
            update();
            if (this.showPromotion) {
                this.countdownTimer = setInterval(update, 1000);
            }
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            if (window.innerWidth > 950 && this.isMobileMenuOpen) {
                this.closeMobileMenu();
            }
        },
        closePromotion() {
            if (!this.isMobile) return;

            const promotionBar = document.querySelector('.PromotionBar');
            if (promotionBar) {
                promotionBar.style.height = '0';
                promotionBar.style.opacity = '0';
                promotionBar.style.paddingTop = '0';
                promotionBar.style.paddingBottom = '0';

                setTimeout(() => {
                    this.isPromotionClosedMobile = true;
                    localStorage.setItem('promotionClosedMobile', 'true');
                }, 300);
            }
        },
        checkStoredPromotionState() {
            const isClosedMobile = localStorage.getItem('promotionClosedMobile') === 'true';
            this.isPromotionClosedMobile = isClosedMobile;
        },
        handleScroll() {
            const currentScrollY = window.scrollY;
            this.isScrolled = currentScrollY > 30;

            if (this.isMobileMenuOpen) {
                return;
            }

            const isAtTop = currentScrollY < 100;
            const isAtBottom =
                window.innerHeight + currentScrollY >= document.body.scrollHeight - 50;
            if (isAtTop || isAtBottom) {
                this.isHidden = false;
            } else {
                const scrollDifference = currentScrollY - this.lastScrollY;

                if (Math.abs(scrollDifference) > this.scrollThreshold) {
                    if (scrollDifference > 0) {
                        this.isHidden = true;
                    } else {
                        this.isHidden = false;
                    }

                    this.lastScrollY = currentScrollY;
                }
            }

            if (this.scrollTimer) clearTimeout(this.scrollTimer);

            this.scrollTimer = setTimeout(() => {
                if (this.isHidden && !this.isMobileMenuOpen) {
                    document.addEventListener('mousemove', this.handleMouseNearTop, { once: true });
                }
            }, 1500);
        },
        handleMouseNearTop(event) {
            if (event.clientY < 60 && this.isHidden) {
                this.isHidden = false;
            }
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            if (this.isMobileMenuOpen) {
                this.isHidden = false;
            }
        },
        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        },
        trackBlogNavigation(source, device) {
            trackNavigation.externalLinkClick('/blog', 'blog_navigation', {
                source,
                device,
                location: 'header',
            });
        },
        handleBlogClick() {
            this.trackBlogNavigation('header', 'mobile');
            this.closeMobileMenu();
        },
        handleMobileNavClick(item) {
            if (!item.isRouterLink) {
                this.closeMobileMenu();
                this.$nextTick(() => {
                    const element = document.querySelector(item.url);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            }
        },
        getPromotionRedirectUrl() {
            const currentPath = this.$route.path;

            if (currentPath === '/' || currentPath === '/promotion') {
                return '/register?source=header_promotion';
            }

            return '/promotion?source=header_promotion';
        },
    },
};
</script>

<style lang="scss">
.SiteHeaderWrapper {
    position: relative;
}

.PromotionBar {
    width: 100%;
    background-color: #b03543;
    padding: 10px 0;
    color: white;
    z-index: 250;
    position: fixed;
    border: 0.5px solid transparent;
    border-radius: 0 0 16px 16px;
    top: 0;
    transition:
        all 0.3s ease,
        border-color 0.3s ease;
    overflow: hidden;

    @media (max-width: $breakpoint-tablet-portrait) {
        z-index: 10;
    }

    &--bottom {
        top: auto;
        bottom: 0;
        border: 0.5px solid transparent;
        border-radius: 16px 16px 0 0;
        padding: 12px 0;
    }

    .PromotionContent {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
        position: relative;

        i {
            font-size: 24px;
            flex-shrink: 0;
        }

        span {
            font-size: 1rem;
        }

        .PromotionButton {
            background-color: white;
            color: #b03543;
            padding: 5px 15px;
            border-radius: 50px;
            font-weight: 700;
            font-size: 0.9rem;
            text-decoration: none;
            transition: all 0.3s ease;
            white-space: nowrap;
            flex-shrink: 0;

            &:hover {
                background-color: #f3f4f6;
                transform: translateY(-2px);
            }
        }

        .PromotionCountdown {
            display: none;
            align-items: center;
            gap: 8px;
            background: rgba(255, 255, 255, 0.22);
            border: 0.5px solid rgba(255, 255, 255, 0.38);
            color: #fff;
            padding: 6px 12px;
            border-radius: 999px;
            font-weight: 800;
            font-size: 0.98rem;
            line-height: 1;
            letter-spacing: 0.015em;
            font-variant-numeric: tabular-nums;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
            backdrop-filter: blur(6px);
            -webkit-backdrop-filter: blur(6px);

            i {
                font-size: 18px;
                opacity: 0.95;
            }
        }

        .PromotionCloseButton {
            background: rgba(0, 0, 0, 0.15);
            border: none;
            color: white;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: none; /* Hidden by default on desktop */
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 0;
            transition: all 0.2s ease;
            flex-shrink: 0;

            i {
                font-size: 20px;
            }

            &:hover {
                background: rgba(0, 0, 0, 0.25);
            }

            &:active {
                transform: scale(0.95);
            }
        }

        @media (max-width: 950px) {
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 10px;
            padding: 0 15px;

            span {
                flex-basis: 100%;
                order: 1;
                padding-right: 30px;
            }

            i {
                order: 0;
                margin-top: 2px;
            }

            .PromotionButton {
                order: 2;
                margin-bottom: 5px;
                width: 100%;
                text-align: center;
                display: block;
            }

            .PromotionCountdown {
                display: inline-flex;
                order: 2;
                max-width: 100%;
            }

            .PromotionCloseButton {
                position: absolute;
                top: 0;
                right: 15px;
                display: flex; /* Show only on mobile */
            }
        }
    }
}

.SiteHeader {
    width: 100%;
    position: fixed;
    z-index: 200;
    left: 0;
    right: 0;
    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    background: transparent;
    top: 0;
    transform: translateY(0);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);

    * {
        transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    @media (max-width: 950px) {
        margin-top: 0px !important;
    }

    &.is-scrolled {
        padding: 0;
        transform: translateY(-34px);
        background: rgba(5, 1, 44, 0.85);
        border-radius: 0 0 24px 24px;
        padding-top: 10px;
        transition:
            all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
            border-color 0.3s ease;

        @media (max-width: 950px) {
            transform: translateY(0px);
        }

        .SiteButton {
            display: flex;
        }

        .SiteHeader-Wrap {
            margin: 8px auto;
            border-radius: 24px;
            padding: 12px 20px;
            position: relative;

            @media (max-width: 950px) {
                background: transparent;
                border: none;
                border-radius: 0;
                backdrop-filter: blur(0);
                -webkit-backdrop-filter: blur(0);
                max-width: unset;
                margin: 0;
                box-shadow: none;
                transform: translateY(0px);
                padding: 0;

                .Logo {
                    display: none;
                }
            }
        }
    }

    &.is-hidden {
        transform: translateY(-170px);
        box-shadow: none;

        @media (max-width: 950px) {
            transform: translateY(0px);
        }
    }

    .SiteHeader-Wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
        transition: all 0.4s cubic-bezier(0.33, 1, 0.68, 1);
        @media (max-width: 950px) {
            padding: 15px;
        }
    }

    .Logo {
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        padding: 4px 12px;
        border-radius: 16px;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
            transition: left 0.6s ease;
        }

        &:hover::before {
            left: 100%;
        }

        img {
            width: 54px;
            height: 54px;
            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            border-radius: 12px;
            position: relative;
            z-index: 1;
        }

        .LogoText {
            color: white;
            font-size: 22px;
            font-weight: 600;
            margin-left: 16px;
            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            letter-spacing: -0.02em;
            position: relative;
            z-index: 1;
        }

        &:hover {
            transform: translateY(-2px);

            img {
                transform: scale(1.05);
            }

            .LogoText {
                color: rgba(255, 255, 255, 0.95);
                text-shadow: 0 2px 8px rgba(255, 255, 255, 0.1);
            }
        }
    }

    .Navigation {
        display: flex;
        align-items: center;
    }

    .DesktopNav {
        display: flex;
        align-items: center;

        @media (max-width: 950px) {
            display: none;
        }
    }

    .NavigationItem {
        font-size: 15px;
        color: rgba(255, 255, 255, 0.8);
        letter-spacing: -0.01em;
        text-decoration: none;
        margin-right: 24px;
        font-weight: 500;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        padding: 8px 16px;
        border-radius: 12px;
        border: 0.5px solid transparent;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.08), transparent);
            transition: left 0.5s ease;
        }

        &:hover::before,
        &.isActive::before {
            left: 100%;
        }

        &:hover,
        &.isActive {
            color: white;
            background: rgba(255, 255, 255, 0.05);
            transform: translateY(-1px);
            border: 0.5px solid rgba(255, 255, 255, 0.12);

            &::after {
                transform: scaleX(1);
            }
        }

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 0;
            height: 2px;
            background: linear-gradient(135deg, #5eead4, #0891b2);
            border-radius: 1px;
            transform: translateX(-50%) scaleX(0);
            transition: transform 0.3s ease;
        }

        &.isActive::after {
            transform: translateX(-50%) scaleX(1);
        }
    }

    .AuthButtons {
        display: flex;
        align-items: center;
        gap: 16px;

        @media (max-width: 950px) {
            .SiteButton {
                position: absolute;
                top: -25px;
                right: 50px;
                width: 100px;
                z-index: 301;
                display: flex;
                padding: 10px 16px;
                border-radius: 20px;
                transition:
                    all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                    border-color 0.3s ease;

                &:hover {
                    transform: translateY(-2px);
                }
            }
        }
    }

    .Hamburger {
        display: none;
        background: none;
        border: none;
        padding: 9px;
        cursor: pointer;
        position: fixed;
        top: 15px;
        right: 15px;
        z-index: 301;
        width: 48px;
        height: 48px;
        border-radius: 16px;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        margin-left: 12px;
        background: linear-gradient(135deg, rgba(5, 1, 44, 0.9) 0%, rgba(5, 1, 44, 0.8) 100%);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border: 0.5px solid rgba(255, 255, 255, 0.1);

        &:hover {
            transform: translateY(-2px);
            border: 0.5px solid rgba(255, 255, 255, 0.2);
            background: linear-gradient(135deg, rgba(5, 1, 44, 0.95) 0%, rgba(5, 1, 44, 0.85) 100%);
        }

        span {
            display: block;
            width: 24px;
            height: 2px;
            background-color: white;
            margin: 6px auto;
            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            border-radius: 1px;
        }

        @media (max-width: 950px) {
            display: block;
        }
    }

    .MobileMenu {
        background: linear-gradient(135deg, rgba(5, 1, 44, 0.98) 0%, rgba(5, 1, 44, 0.95) 100%);
        backdrop-filter: blur(25px);
        -webkit-backdrop-filter: blur(25px);
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        width: 320px;
        display: flex;
        flex-direction: column;
        z-index: 301;
        border: 0.5px solid transparent;
        overflow-y: auto;

        .MobileMenuHeader {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px 20px;
            border-bottom: 0.5px solid rgba(255, 255, 255, 0.08);
            background: linear-gradient(
                135deg,
                rgba(255, 255, 255, 0.02) 0%,
                rgba(255, 255, 255, 0.01) 100%
            );

            .BrandingMobile {
                display: flex;
                align-items: center;

                .MobileLogo {
                    width: 38px;
                    height: 38px;
                    border-radius: 10px;
                }

                .MobileLogoText {
                    color: white;
                    font-size: 20px;
                    font-weight: 600;
                    margin-left: 12px;
                    letter-spacing: -0.02em;
                }
            }

            .MobileMenuClose {
                background: rgba(255, 255, 255, 0.05);
                border: 0.5px solid transparent;
                color: white;
                cursor: pointer;
                width: 44px;
                height: 44px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 14px;
                transition:
                    all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                    border-color 0.3s ease;

                i {
                    font-size: 24px;
                }

                &:hover {
                    background: rgba(255, 255, 255, 0.1);
                    transform: scale(1.05);
                    border: 0.5px solid rgba(255, 255, 255, 0.15);
                }
            }
        }

        .MobileNavItems {
            padding: 16px 0;

            a {
                display: block;
                font-size: 16px;
                color: rgba(255, 255, 255, 0.8);
                padding: 16px 24px;
                text-decoration: none;
                transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                position: relative;
                font-weight: 500;
                letter-spacing: -0.01em;
                border-radius: 0 20px 20px 0;
                margin: 2px 8px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 0;
                    height: 2px;
                    background: linear-gradient(135deg, #5eead4, #0891b2);
                    transform: translateY(-50%);
                    transition: width 0.3s ease;
                    border-radius: 1px;
                }

                &:hover,
                &.isActive {
                    color: white;
                    background: linear-gradient(
                        135deg,
                        rgba(255, 255, 255, 0.08) 0%,
                        rgba(255, 255, 255, 0.04) 100%
                    );
                    transform: translateX(4px);

                    &::before {
                        width: 24px;
                    }
                }
            }
        }

        .MobileAuthButtons {
            margin-top: auto;
            padding: 24px 20px 80px;
            border-top: 0.5px solid rgba(255, 255, 255, 0.08);
            display: flex;
            flex-direction: column;
            gap: 12px;
            background: linear-gradient(
                135deg,
                rgba(255, 255, 255, 0.02) 0%,
                rgba(255, 255, 255, 0.01) 100%
            );

            .MobileLoginButton {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 16px;
                text-decoration: none;
                border-radius: 16px;
                font-weight: 600;
                font-size: 15px;
                transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                position: relative;
                overflow: hidden;

                i {
                    margin-right: 10px;
                    font-size: 18px;
                }

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(
                        90deg,
                        transparent,
                        rgba(255, 255, 255, 0.1),
                        transparent
                    );
                    transition: left 0.6s ease;
                }

                &:hover::before {
                    left: 100%;
                }
            }

            .MobileLoginButton {
                background: linear-gradient(135deg, #5eead4, #0891b2);
                color: rgba(5, 1, 44, 0.9);
                border: 0.5px solid transparent;
                font-weight: 700;

                &:hover {
                    transform: translateY(-3px);
                    border: 0.5px solid rgba(255, 255, 255, 0.3);
                    background: linear-gradient(135deg, #67e8d4, #0ea5c0);
                }
            }
        }
    }

    .MobileMenuOverlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 299;
        backdrop-filter: blur(3px);
    }
}

.slide-in-enter-active,
.slide-in-leave-active {
    transition:
        transform 0.4s cubic-bezier(0.19, 1, 0.22, 1),
        opacity 0.4s ease;
}

.slide-in-enter,
.slide-in-leave-to {
    transform: translateX(100%);
    opacity: 0;
}
</style>
